import serverInterface from 'server-interface';

import externalEventCodes from 'event-system/codes/external';

import {
  applyTraits
} from 'utilities/javascript';

import {
  getIndicesByPropertyValue
} from 'utilities/collection';

import DataManagerTraits from '../traits';

class CustomerFiltersManager {

  constructor(application) {

    this.initialized = false;
    this.collection = [];

    this.application = application;

  }

  handleCreatedEvent(payload) {

    this.tryAdd(payload.customerFilter);

  }

  handleUpdatedEvent(item) {

    this.tryRemove(item._id);
    this.tryAdd(item);

  }

  handleDeletedEvent(payload) {

    this.tryRemove(payload.collection._id);

  }

  registerEventHandlers() {

    this.application.eventSystem.internal.on(externalEventCodes.CUSTOMER_FILTER_CREATED, this.handleCreatedEvent.bind(this));
    this.application.eventSystem.internal.on(externalEventCodes.CUSTOMER_FILTER_UPDATED, this.handleUpdatedEvent.bind(this));

  }

  async loadAll() {

    this.collection = await serverInterface.startup.users.customerFilters.getCustomerFilters();

  }

  async create(payload) {

    let item = await serverInterface.startup.users.customerFilters.createCustomerFilter(payload);

    this.tryAdd(item);

    return item;

  }

  async update(itemId, payload) {

    return serverInterface.startup.users.customerFilters.updateCustomerFilterByCustomerFilterId(itemId, payload);

  }

  async delete(itemId) {

    await serverInterface.startup.users.customerFilters.deleteCustomerFilterByCustomerFilterId(itemId);

    this.tryRemove(itemId);

  }

  getDefaultFilter() {

    const indices = getIndicesByPropertyValue(this.collection, 'name', 'All');

    for (let index of indices) {

      if (this.collection[index].system === true) {
        return this.collection[index];
      }

    }

    return null;

  }

  getHiddenUsersFilter() {

    const indices = getIndicesByPropertyValue(this.collection, 'name', 'Hidden');

    for (let index of indices) {

      if (this.collection[index].system === true) {
        return this.collection[index];
      }

    }

    return null;

  }

  async initialize(bootstrapData) {

    this.registerEventHandlers();

    this.collection = bootstrapData.customerFilters;

    this.initialized = true;

  }

}

export default applyTraits(CustomerFiltersManager, [DataManagerTraits]);